import { useQuery } from "@tanstack/react-query";

import { listRdos } from "@/adapters/api";
import type { RdoSummary } from "../types.ts";
import { toRdoSummary } from "../utils/map.ts";
import { rdosQueryKey } from "./use-rdos.ts";

const ISSUED_RDOS_LIMIT = 100;

export function useIssuedRdosSince(
	constructionId: string | undefined,
	from: string | undefined,
	enabled = true,
) {
	return useQuery({
		queryKey: [...rdosQueryKey(constructionId), "issued-since", from ?? ""],
		queryFn: async (): Promise<RdoSummary[]> => {
			const response = await listRdos(
				// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
				constructionId!,
				{ from, status: "finalized", pageSize: ISSUED_RDOS_LIMIT },
			);
			return response.items.map(toRdoSummary);
		},
		enabled: enabled && !!constructionId && !!from,
		staleTime: 15_000,
	});
}
